import React from 'react'

import SvgIcon from './SvgIcon.js'

export default () => (
  <SvgIcon>
    <path d="M3,9.99508929 C3,8.8932319 3.89989752,8 4.99124431,8 L29.0087557,8 C30.1084896,8 31,8.8926228 31,9.99508929 L31,24.0049107 C31,25.1067681 30.1001025,26 29.0087557,26 L4.99124431,26 C3.89151044,26 3,25.1073772 3,24.0049107 L3,9.99508929 Z M26.1666667,18.5 L27,18.5 L27,17 L26.1666667,17 L7.83333333,17 L7,17 L7,18.5 L7.83333333,18.5 L26.1666667,18.5 Z M23.125,22.5 L24,22.5 L24,21 L23.125,21 L10.875,21 L10,21 L10,22.5 L10.875,22.5 L23.125,22.5 Z" />
  </SvgIcon>
)
